import { format } from "date-fns";
import React from "react";
import { LOGO_HOTAREA, STORE_IMAGES } from "../../../../constants/urls";
import * as S from "./Styled";
import { CircularProgress } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import Default from "../../../../components/Modal/Default/Default";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

export function NewCoupons({
  slug,
  coupons,
  getcouponRedirect,
  utmSource,
  utmCampaign,
  userId,
  incentiveId,
  showAlert,
  openCoupon,
  itemWidth,
  topCoupons,
  isAuthenticated,
  isMobile,
  modalTitle,
  logo
}) {
  const [open, setOpen] = React.useState(false);
  const [loadingRedirectId, setLoadingRedirectId] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  if (!coupons?.data) {
    return <CircularProgress size={24} color="inherit" />;
  }



  const renderAuthenticatedButton = (coupon, onClickRedirect) => {
    if (coupon.type === "ONLINE") {
      return (
        <S.ButtonWrapper className="botao-cupom"  onClick={() => openCoupon(coupon)}>
          <S.CouponButton>Ver Cupom</S.CouponButton>
        </S.ButtonWrapper>
      );
    }

    return (
      <S.ButtonWrapper id="pegadoroferta" className="botao-oferta click-redirect" onClick={onClickRedirect}>
      <S.CouponButton>
        {loadingRedirectId === coupon.id ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Ver Oferta"
        )}
      </S.CouponButton>
      </S.ButtonWrapper>
    );
  };

  const renderUnauthenticatedButton = (coupon) => {
    if (coupon.type === "ONLINE") {
      return (
        <S.ButtonWrapper className="botao-cupom"  onClick={() => handleClickOpen()}>

          
          <S.CouponButton>
            Ver Cupom

                      <S.LockBadge
          >
            <LockIcon
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",   // mobile
                  md: "1.2rem", // desktop
                },
              }}
            />
          </S.LockBadge>

          </S.CouponButton>
        </S.ButtonWrapper>
      );
    }

    return (
      <S.ButtonWrapper className="botao-oferta" onClick={() => handleClickOpen()}>

        <S.CouponButton>
        {loadingRedirectId === coupon.id ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Ver Oferta"
        )}
          <S.LockBadge>
           <LockIcon
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",   // mobile
                  md: "1.2rem", // desktop
                },
              }}
            />
          </S.LockBadge>
      </S.CouponButton>
      </S.ButtonWrapper>
    );
  };


  return (
    <>
      {coupons.data.map((coupon,index) => {
        const formattedDate = coupon.endDate
          ? format(new Date(coupon.endDate), "dd/MM/yyyy")
          : "-";

        const formatPercentage = (value) => {
          if (value == null) return "0%";
          const formattedValue = parseFloat(value)
            .toFixed()
            .replace(/\.0$/, "");
          return `${formattedValue}%`;
        };

        const onClickRedirect = async () => {
          try {
            setLoadingRedirectId(coupon.id);

            const trackedLink = await getcouponRedirect({
              link: coupon.linkUrl,
              source: utmSource,
              campaign: utmCampaign,
              userId: `${userId}`,
              coupon: `${coupon.id}`,
              store: coupon.store.slug,
              incentive: +incentiveId,
            });

            if (!trackedLink) {
              showAlert("Link de redirecionamento não retornado.", "error");
              return;
            }

            const isMobile = /Android|iPhone|iPad|iPod/i.test(
              navigator.userAgent
            );

            isMobile
              ? window.location.assign(trackedLink)
              : window.open(trackedLink, "_blank", "noopener,noreferrer");
          } catch (error) {
            showAlert(
              `Erro ao redirecionar cupom: ${error.message}`,
              "error"
            );
          } finally {
            setLoadingRedirectId(null);
          }
        };

        return (
          <S.CouponBox key={index} width={itemWidth}>
            <S.ContainerImageDescription>
             <S.CouponImage
                src={`${STORE_IMAGES}${coupon.store.slug || "default"}.png`}
                alt=""
              />
              <S.CouponDescription>{coupon.name}</S.CouponDescription>
              
            </S.ContainerImageDescription>

            <S.CouponExpiration>
              {isMobile? <AccessAlarmIcon sx={{fontSize: "10px"}}/> : "Data de expiração: " }  {formattedDate}
            </S.CouponExpiration>
            {isAuthenticated ? renderAuthenticatedButton(coupon,onClickRedirect ) : renderUnauthenticatedButton(coupon )}

            {!!coupon.store.cashbackOn && coupon.store.cashbackPercentage > 0 && (
              <S.CouponCashback>
                +{formatPercentage(
                  coupon.store.cashbackPercentage * 2
                )}{" "}
                  {isMobile? "cashback": "de cashback"}
              </S.CouponCashback>
            )}
            {topCoupons && (
              <S.Selo
                src={`https://static.meucupom.com/media/2025%20-%20Updates/Clube%20Do%20Aluno/IMAGENS_${String(index + 1).padStart(2, '0')}.png`}
                alt={`Top ${index + 1}`}
              />
            )}
          </S.CouponBox>
        );
      })}
      <Default 
      slug={slug}
      name={modalTitle}
      open={open}
      handleClose={handleClose}
      incentiveId={incentiveId}
      logo={logo}
      />
    </>
  );
}